import { Directive, HostBinding } from "@angular/core";

@Directive({
    selector: "[bciTableStripedHorizontal]",
    standalone: false
})
export class TableStripedHorizontalDirective {
  @HostBinding("class.table-striped-horizontal") true: boolean;

  constructor() {}
}
